import React, { useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import axios from '../../../constents/axios'

const CloneSelectedTests = ({show,handleClose,ids,onSuccess, submittedCourse}) => {
        const [labels, setLabels] = useState([]);
        const [selectedLabel, setSelectedLabel] = useState("");
        const [courses, setCourses] = useState([]);
        const [selectedCourse, setSelectedCourse] = useState("");
        const [selectedType, setSelectedType] = useState("");

            const fetchLabels = async () => {
                try {
                    const response = await axios.get("/fetch-label", {
                        headers: {
                            autherisation: "V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa",
                        },
                    });
                    setLabels(response.data.data);
                } catch (error) {
                    console.error("Error fetching labels:", error);
                }
            };

            const fetchCourses = async (labelId) => {
                try {
                    const response = await axios.get(`/courseId/${labelId}`, {
                        headers: {
                            autherisation: "V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa",
                        },
                    });
                    const filteredCourses = response.data.data.filter(
                        (course) => course.course_id !== submittedCourse
                    );
                    setCourses(filteredCourses);
                } catch (error) {
                    console.error("Error fetching courses:", error);
                }
            };
            

    const handleSelectedClone = async () => {
        try {
            const response = await axios.post(`/tests/cloneSelectedTests`,{testIds:ids,  courseId: selectedCourse}
            ,{
                headers: {
                    'autherisation': `V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa` // Replace with your actual token
                }
            })
            handleClose()
            onSuccess()
        } catch (error) {
            console.log(error)
        }
    }

        useEffect(() => {
            fetchLabels();
        
        }, []);

            useEffect(() => {
                if (selectedLabel) {
                    fetchCourses(selectedLabel);
                }
            }, [selectedLabel]);
  return (
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Assign Test</Modal.Title>
        </Modal.Header>
        <Form  className="row g-1">
        <Modal.Body>
                <Form.Group className="col-12 mb-3">
                    <Form.Label>Label</Form.Label>
                    <Form.Control as="select" onChange={(e) => setSelectedLabel(e.target.value)} value={selectedLabel}>
                        <option value="">Select Label</option>
                        {labels.map((label) => (
                            <option key={label.id} value={label.id}>
                                {label.label}
                            </option>
                        ))}
                    </Form.Control>
                </Form.Group>
                <Form.Group className="col-12 mb-3">
                    <Form.Label>Course</Form.Label>
                    <Form.Control as="select" onChange={(e) => setSelectedCourse(e.target.value)} value={selectedCourse}>
                        <option value="">Select Course</option>
                        {courses.map((course) => (
                            <option key={course.course_id} value={course.course_id}>
                                {course.title}
                            </option>
                        ))}
                    </Form.Control>
                </Form.Group>
        </Modal.Body>
        <Modal.Footer>
        <Button onClick={handleSelectedClone} className="mt-2" variant="primary" >
                        Submit
                    </Button>
        </Modal.Footer>
            </Form>
    </Modal>
  )
}

export default CloneSelectedTests